import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=6e8fd88e&scoped=true&"
import script from "./Glossary.vue?vue&type=script&lang=js&"
export * from "./Glossary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8fd88e",
  null
  
)

export default component.exports